import { createActions } from 'redux-actions';

export const {
  setCurrentOnboardingStep,
  setFormValues,
  setNextOnboardingStep,
  setPrevOnboardingStep,
  enableNextButton,
  disableNextButton,
} = createActions(
  {
    SET_CURRENT_ONBOARDING_STEP: currentStep => ({ currentStep }),
    SET_FORM_VALUES: values => ({ values }),
    SET_NEXT_ONBOARDING_STEP: formValues => ({ formValues }),
  },
  'SET_PREV_ONBOARDING_STEP',
  'ENABLE_NEXT_BUTTON',
  'DISABLE_NEXT_BUTTON',
);



// WEBPACK FOOTER //
// ./src/store/actions/FreelancerOnboarding/index.js